import { gql } from '__generated__';

export default gql(`
  mutation DeleteOrder($id: ID!) {
    deleteOrder(id: $id) {
      id
    }
  }
`);
